import React from 'react';
import { useSelector } from 'react-redux';
import { withTheme } from 'styled-components';
import {
  Rail,
  RailTrack,
  RailTrail,
  RailStop,
  RailNode,
  RailHalo,
  RailLabel,
} from './styles';

const STOPS = [ 'Waiting', 'Queued', 'Processing', 'Ready' ];

// `stage` is the index of the node the model is sitting on. `frozen` recolors
// the rail for a terminal state and stops the active node pulsing.
const ProgressRail = withTheme(props => {
  const { theme, stage, frozen } = props;
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;
  const themeProps = { theme, $selectedTheme: selectedTheme };
  const fill = (Math.max(stage, 0) / (STOPS.length - 1)) * 100;

  return (
    <Rail {...themeProps}>
      <RailTrack {...themeProps}>
        <RailTrail {...themeProps} $fill={fill} $frozen={frozen} />
      </RailTrack>

      {STOPS.map((label, index) => {
        const active = index === stage;
        const done = index < stage;

        return (
          <RailStop key={label} {...themeProps}>
            <RailNode {...themeProps} $active={active} $done={done} $frozen={frozen}>
              {active && !frozen && <RailHalo {...themeProps} />}
            </RailNode>

            <RailLabel {...themeProps} $active={active}>
              {label}
            </RailLabel>
          </RailStop>
        );
      })}
    </Rail>
  );
});

export { ProgressRail, STOPS };
